
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from './profile.reducer';

import {
    AddressInfo,
    OwnerCenterInfo,
    AthleteInfo,
    SettingsStateKeys
} from '@libs/entity-lib';

export const selectProfileState =
    createFeatureSelector<fromReducer.State>(SettingsStateKeys.CRUD_PROFILE_SOCIAL_SPORT);

export const selectState = createSelector(
    selectProfileState,
    (state) => state
);

export const selectCurrentAddressInfo = createSelector(
    selectProfileState,
    (state): AddressInfo | null => state?.addressInfo
);

export const selectOwnerInfo = createSelector(
    selectProfileState,
    (state): OwnerCenterInfo | null => state?.ownerCenterInfo
);

export const selectUserInfo = createSelector(
    selectProfileState,
    (state): AthleteInfo | null => state?.athleteInfo
);

export const selectSportCenterLoading = createSelector(
    selectProfileState,
    (state) => state?.loading ?? false
  );

export const selectIsUserNameValid = createSelector(
    selectProfileState,
    (state): boolean => state?.isUserNameValid ?? false
);

export const selectIsEmailValid = createSelector(
    selectProfileState,
    (state): boolean => state?.isEmailValid ?? false
);

export const selectIsLoading = createSelector(
    selectProfileState,
    (state): boolean => state?.loading ?? false
);